export const EBlurEffectStates = {
    Show: 'SHOW',
    Hide: 'HIDE',
    Initial: 'INITIAL',
};
